/**
 * Created by andrey on 11.01.18.
 */

const FakeSender = function () {
    BaseSender.call(this);

    this.config = {
        maxTimeout: 30
    };
};

FakeSender.prototype = Object.create(BaseSender.prototype);
FakeSender.prototype.constructor = FakeSender;

FakeSender.prototype.send = function (data) {
    const id = data.id;

    if (!data.message || !data.title) {
        connector.notifications.trigger("stream:error", `empty fake push - ${id}`);
        return;
    }

    return true;
};

FakeSender.prototype.cancel = function () {
};

FakeSender.isAppropriate = function () {
    return connector.config.debugMode;
};